import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchOrder } from '../AdminClasses';
import { addCommas } from '@arema/components/Util';
import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import API from '../API';
import classNames from 'classnames';

var SearchOrderModal = (props: SearchCoreProps<SearchOrder>)=>{
	var { t } = useTranslation();
	return <SearchCoreModal
		title='Buscar ordenes'
		{...props}
		searchData={(query, page, page_size)=>{
			return API.searchOrders(query);
		}}
		pageSize={15}
		table={[
			{ name: 'ID', key: 'order_hash', collapsing: true },
			{ name: t('common.email'), key: 'email' },
			{ name: t('common.status'), key: 'paid', collapsing: true, centered: true, render: (v, a)=>{
				return <div className={classNames('fr label', {
					red: a.cancelled,
					transparent: !a.cancelled && a.expired && !a.paid,
					green: !a.cancelled && a.paid,
					blue: !a.cancelled && !a.paid && !a.expired,
				})}>
					{a.cancelled ? 'Cancelado' : (a.expired ? 'Expirado' : (a.paid ? 'Pagado' : 'Pendiente'))}
				</div>
			} },
			{ name: t('common.total'), key: 'total', collapsing: true, render: addCommas },
		]}
	/>
}

export default SearchOrderModal;